export const banner = {
  loading: "読み込み中",
  alt: {
    purchaseFirst: "初回購入ボーナス",
    purchaseSecond: "2回目購入ボーナス",
    purchaseThird: "3回目購入ボーナス",
    purchaseFourth: "4回目購入ボーナス",
    purchaseFifth: "5回目購入ボーナス",
    dailyBonus: "デイリーボーナス",
    lovense: "Lovense フルコントロール",
    webPayment: "Web決済でお得にポイント購入",
    spuPointBack: "SPUポイントバック",
    reviewReward: "レビュー投稿で50ptもらえる",
    paidy: "Paidyあと払い お支払いは翌月でOK",
  },
} as const;
